import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';

// firebase init - add your own config here
const firebaseConfig = {
  apiKey: 'AIzaSyBLsvajyumaQOqk3eXHTatlqcWE-s7J6Ug',
  authDomain: 'eat-and-shop.firebaseapp.com',
  databaseURL: 'https://eat-and-shop.firebaseio.com',
  projectId: 'eat-and-shop',
  storageBucket: 'eat-and-shop.appspot.com',
  messagingSenderId: '632203826178',
  appId: '1:632203826178:web:6e26da5c297dabc257031b',
};
firebase.initializeApp(firebaseConfig);

// utils
const auth = firebase.auth();
const db = firebase.firestore();

if (process.env.NODE_ENV === 'development') {
  firebase.functions().useEmulator('localhost', 5001);
  firebase.firestore().useEmulator('localhost', 8082);
}
const functions = firebase.functions();
const { firestore } = firebase;

// collection references
const usersCollection = db.collection('users');
const mealsCollection = db.collection('meals');
const defaultMealsCollection = db.collection('defaultMeals');
const workspacesCollection = db.collection('workspaces');
const plannedMealsCollection = db.collection('plannedMeals');
const ingredientsCollection = db.collection('ingredients');
const ingredientMapIngredient = db.collection('ingredientMapIngredient');
const bucketsCollection = db.collection('bucketsCollection');

// export utils/refs
export {
  db,
  auth,
  firestore,
  functions,
  usersCollection,
  mealsCollection,
  defaultMealsCollection,
  plannedMealsCollection,
  workspacesCollection,
  ingredientsCollection,
  ingredientMapIngredient,
  bucketsCollection,
};
